import Provider, { createProvider } from './components/Provider';
import connectAdvanced from './components/connectAdvanced';
import connect from './connect/connect';

export { Provider, createProvider, connectAdvanced, connect };


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-redux/es/index.js
// module id = ./node_modules/react-redux/es/index.js
// module chunks = 0 6 9 11